import axios from "../../apis/axios";

export const getDashboard = async () => {
  const result = await axios.get(`v1/users/dashboard`);
  return result.data.data;
};

export const list = async ({
  limit = 10,
  page = 1,
  name = "",
  email = "",
  phone = "",
  city = "",
  state = "",
  type = "",
  position = "",
  implementer_id = "",
  id = "",
  sort = "",
  field = "",
  search = "",
}) => {
  const result = await axios.get(
    `v1/users?limit=${limit}&page=${page}&sort=${sort}&field=${field}&search=${search}&name=${name}&email=${email}&phone=${phone}&city=${city}&state=${state}&type=${type}&position=${position}&implementer_id=${implementer_id}&id=${id}`
  );
  return result.data.data;
};

export const getPermissions = async () => {
  const result = await axios.get(`v1/permissions`);
  return result.data.data;
};
